module.exports = __webpack_public_path__ + "img/area-part3-131.b32a6e66.png";